"use client";

import Link from "@casino/client/components/Link";

type Props = {
  href: string;
  ariaLabel?: string;
};

const SlideLink: FC<Props> = ({ href, ariaLabel = "Open slide", children }) => (
  <div className="relative w-full">
    <Link href={href} aria-label={ariaLabel} className="absolute inset-0 z-1" />
    <div className="pointer-events-none relative z-2 [&_a]:pointer-events-auto [&_button]:pointer-events-auto">
      {children}
    </div>
  </div>
);

export default SlideLink;
